export const createIsoDate = () => new Date().toISOString().slice(0, 10);

// 2000-12-31
export const dateToDE = date => `${date.substring(8, 10)}.${date.substring(5, 7)}.${date.substring(0, 4)}`;

export const timeToDE = date => `${date.substring(11, 16)}`;

export const dateTimeToDE = date => `${dateToDE(date)}, ${timeToDE(date)} Uhr`;

// sorting functions
export const orderByName = (o1, o2) => {
	const sn1 = o1.surname.toUpperCase();
	const sn2 = o2.surname.toUpperCase();
	if (sn1 < sn2)
		return -1;
	if (sn1 > sn2)
		return 1;

	const n1 = o1.name.toUpperCase();
	const n2 = o2.name.toUpperCase();
	if (n1 === n2)
		return 0;
	return n1 < n2 ? -1 : 1;
};

export const orderByField = field => ({[field]: v1}, {[field]: v2}) => {
	if (v1 === v2)
		return 0;
	return v1 > v2 ? -1 : 1;
};

export const orderByModified = orderByField('lastModified');

export const orderFuncs = {
	byName: {
		label: 'A-Z',
		func: orderByName,
	},
	byModified: {
		icon: 'bi-clock',
		func: orderByModified,
	},
};

const enabledThen = func => (o1, o2) => {
	const e1 = o1.enabled;
	const e2 = o2.enabled;

	// order enabled entries before disabled ones
	if (e1 !== e2)
		return e1 ? -1 : 1;

	// defer to passed function if enabledness is the same
	return func(o1, o2);
};

export const trainerOrderFuncs = {
	byName: {
		label: 'A-Z',
		func: enabledThen(orderByName),
	},
	byModified: {
		icon: 'bi-clock',
		func: enabledThen(orderByModified),
	},
};
